// src/pages/LandingPage.tsx
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';

const LandingPage: React.FC = () => {
  const { me, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && me) {
      const home = me.isServiceAdmin ? '/admin' : me.isCompanyAdmin ? '/company' : '/projects';
      nav(home, { replace: true });
    }
  }, [loading, me, nav]);

  const isLoggedIn = !!me;

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <header className="border-b bg-white">
        <div className="mx-auto max-w-5xl px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-lg bg-sky-700" />
            <span className="text-sm font-semibold text-gray-900">
              KI Project Manager
            </span>
          </div>
          {isLoggedIn ? (
            <Link
              to="/projects"
              className="text-xs text-sky-700 hover:underline"
            >
              내 프로젝트로 이동
            </Link>
          ) : (
            <Link
              to="/login"
              className="text-xs text-sky-700 hover:underline"
            >
              로그인
            </Link>
          )}
        </div>
      </header>

      <main className="flex-1 flex items-center">
        <div className="mx-auto max-w-5xl px-4 py-10 grid gap-10 md:grid-cols-[2fr,1.5fr] items-center">
          {/* 왼쪽: 카피 */}
          <div className="space-y-4">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
              EPC 프로젝트를 위한
              <br />
              통합 WBS & 진도 관리 시스템
            </h1>
            <p className="text-sm text-gray-600 leading-relaxed">
              하나의 화면에서 WBS, 진도(EV), 리스크, 마일스톤, 지급(progress payment)까지
              관리하세요. EPC, 하청, 발주처(Employer), PMC가 각각의 역할에 맞게
              접근할 수 있도록 설계된 프로젝트 관리 플랫폼입니다.
            </p>

            <div className="flex flex-wrap gap-3 text-xs">
              {isLoggedIn ? (
                <>
                  <Link
                    to="/projects"
                    className="rounded-lg bg-sky-700 text-white px-4 py-2 hover:bg-sky-800"
                  >
                    내 프로젝트로 이동
                  </Link>
                  <Link
                    to="/organization"
                    className="rounded-lg border border-gray-300 px-3 py-2 text-gray-700 hover:bg-gray-50"
                  >
                    회사 관리(Organization)
                  </Link>
                  <Link
                    to="/admin"
                    className="rounded-lg border border-gray-300 px-3 py-2 text-gray-700 hover:bg-gray-50"
                  >
                    Admin Console
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="rounded-lg bg-sky-700 text-white px-4 py-2 hover:bg-sky-800"
                  >
                    로그인
                  </Link>
                  <span className="text-[11px] text-gray-500">
                    (테스트용 계정이 필요하신 분은 kyoungil.kim.kr@gmail.com으로 문의 주세요.)
                  </span>
                </>
              )}
            </div>
          </div>

          {/* 오른쪽: 카드 3개 요약 */}
          <div className="grid gap-3 text-xs">
            <div className="rounded-xl border bg-white p-4 shadow-sm">
              <div className="font-semibold text-gray-800 mb-1">WBS & 진도 관리</div>
              <p className="text-gray-600">
                WBS 트리, 가중치, 일정, Earned Value를 한 곳에서 관리하고
                주간 진도 제출·승인 흐름을 지원합니다.
              </p>
            </div>
            <div className="rounded-xl border bg-white p-4 shadow-sm">
              <div className="font-semibold text-gray-800 mb-1">역할 기반 접근제어</div>
              <p className="text-gray-600">
                PM, 하청사, QC, PMC, Employer 등 각 역할별로
                볼 수 있는 WBS 범위와 편집 권한을 세밀하게 제어합니다.
              </p>
            </div>
            <div className="rounded-xl border bg-white p-4 shadow-sm">
              <div className="font-semibold text-gray-800 mb-1">결제·마일스톤 연계</div>
              <p className="text-gray-600">
                WBS 진도와 공정률을 기반으로 마일스톤 및 지급(Progress Payment)을
                연계하여 관리할 수 있습니다.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
